import { BigPill, SmallPill } from '../../../components/pills';
import { PasswordButton, UploadButton, DeleteButton } from '../../../components/buttons';
import React from "react";
import AlertManager from '../../../managers/alert/alert-manager';

import Input from '../../../components/input-with-label';
import Section from './account-section';

import MeApi from '../../../lib/users/me-api';


export default class AccountDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            user : {
                user_profile : {},
                company : {},
                roles : []
            },
        };
    }

    componentDidMount() {
        this.getUser();
        this.props.onSaveSet(this.handleSave.bind(this));
    }
    

    handleSave() {
        MeApi.update(this.state.user, (e) => {
            Object.keys(e).forEach(key => {
                this.props.addError(true, e[key], key);
            });
        }).then(response => {
            AlertManager.success('Details updated');
            this.props.setValidation([]);
        });
    }


    getUser() {
        MeApi.me().then(user => {
            if(user.user_profile !== null) {
                user = Object.assign({}, user, user.user_profile);
            }
            this.setState({user : user});
        });
    }

    handleChange(e) {
        const { name, value } = e.target;

        this.setState({
            user : Object.assign({}, this.state.user, {
                [name] : value
            })
        });
    }

    render() {
        const { handleChange } = this.props;
        const { user } = this.state;

        return (
            <div class="account__details">
                <Section title="About Me" className="account__top">
                    <div className="account-section__left">
                        <div class="website-row">
                            <Input name="first_name" value={user.first_name} placeholder="First name" onChange={this.handleChange.bind(this)} errors={this.props.getError('first_name')}/>
                            <Input name="last_name" value={user.last_name} placeholder="Last name" onChange={this.handleChange.bind(this)} errors={this.props.getError('last_name')}/>
                        </div>
                        <div class="website-row">
                            <Input name="email" value={user.email} placeholder="Email address" onChange={this.handleChange.bind(this)} errors={this.props.getError('email')}/>
                        </div>
                        <div class="account-information">
                            <div className="account-information__item">
                                <p className="account-information-item__title">My Company</p>

                                <BigPill>{user.company.name}</BigPill>
                            </div>
                            {/*<div className="account-information__item">*/}
                            {/*    <p className="account-information-item__title">My Position</p>*/}
                            {/*    <BigPill>User position displayed here</BigPill>*/}
                            {/*</div>*/}
                        </div>
                    </div>
                    <div className="account-section__right">
                        {/*<div className="account-profile">*/}
                        {/*    <div className="account-information__item">*/}
                        {/*        <div>*/}
                        {/*            <p className="account-information-item__title">Profile Picture</p>*/}
                        {/*            <div className="account-profile__picture"></div>*/}
                        {/*        </div>*/}
                        {/*        <div class="website-row">*/}
                        {/*            <UploadButton />*/}
                        {/*            <DeleteButton />*/}
                        {/*        </div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </Section>

                <Section title="My Roles" subtitle="These are the permissions that you have been granted">
                    <div className="account__permissions">
                        { user.roles.map((role, index) => <SmallPill key={index}>{role.name}</SmallPill>) }
                    </div>
                </Section>
            </div>
        )

    }


}
